export enum ChannelTier {
  TIER_0 = 'TIER_0',
  TIER_50 = 'TIER_50',
  TIER_1K = 'TIER_1K',
  TIER_10K = 'TIER_10K',
  TIER_100K = 'TIER_100K',
  TIER_UNLIMITED = 'TIER_UNLIMITED',
}


export enum ChannelTransport {
  whatsapp = 'whatsapp',
  /* WABA каналы */
  wapi = 'wapi',
  instagram = 'instagram',
  tgapi = 'tgapi',
  /* TG боты */
  telegram = 'telegram',
}

export enum ChannelSubscriptionState {
  active = 'active',
  init = 'init',
  disabled = 'disabled',
  phoneUnavailable = 'phoneUnavailable',
  qr = 'qr',
  openElsewhere = 'openElsewhere',
  notEnoughMoney = 'notEnoughMoney',
  foreignphone = 'foreignphone',
  unauthorized = 'unauthorized',
  waitForPassword = 'waitForPassword',
  blocked = 'blocked',
  rejected = 'rejected',
}

export interface ChannelSubscription {
  id: string;
  subscriptionId: string;
  userId: string;
  companyId: string;
  transport: ChannelTransport;
  phone: string;
  username: string;
  state: ChannelSubscriptionState;
  tier: ChannelTier;
  activeSinceAt: string;
  createdAt: string;
}
